export default "__VITE_ASSET__COh9574E__"